import React from 'react';
import { Link } from "react-router-dom";
import icon from "../../../images/baig/nav-toggle-icon.png";
import './Navbar.css';
const Navbar = () => {
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light py-3">
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <h1 style={{ color: "white" }}>Shohel Rana</h1>
                    </Link>
                    <button className="navbar-toggler " to="/" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <img src={icon} alt="" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item active">
                                <Link style={{ color: "white" }} className="nav-link mr-3 font-weight-bold" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link style={{ color: "white" }} className="nav-link mr-4 font-weight-bold" to="/about">About</Link>
                            </li>
                            <li className="nav-item">
                                <Link style={{ color: "white" }} className="nav-link mr-4 font-weight-bold" to="/projects">Projects</Link>
                            </li>
                            <li className="nav-item">
                                <Link style={{ color: "white" }} className="nav-link mr-4 font-weight-bold" to="/blogs">Blogs</Link>
                            </li>
                            <li className="nav-item">
                                <Link style={{ color: "white" }} className="nav-link mr-4 font-weight-bold" to="/contact">Contact</Link>
                            </li>
                        </ul>

                        <a className='link' href="https://drive.google.com/file/d/1WnXaYPd9dUaIGXlxd7Md41pK3vXQRKTC/view" target="blank">

                            <button type="button" className='btn project-btn font-weight-bold'>Resume</button>
                        </a>

                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;